import { Pipe, PipeTransform } from '@angular/core';
import { HString } from '../public-api';
import { HInteger } from '../datatypes/HInteger';
import { SimpleTableRowFrontDto } from '../components/core/canvas/SimpleTableDto';
@Pipe({
    name: 'filterColumns'
})
export class FilterColumns implements PipeTransform {
    private result: SimpleTableRowFrontDto[];

    transform(items: SimpleTableRowFrontDto[], searchText: string, filterMetadata?: any): any[] {
        if (!items) {
            if (filterMetadata && typeof filterMetadata !== 'string') {
                filterMetadata.count = 0;
            }
            return [];
        }

        if (!searchText) {
            if (filterMetadata && typeof filterMetadata !== 'string') {
                filterMetadata.count = items.length;
            }
            return items;
        }

        this.result = [];
        // Si searchText es null o undefined, s'estableix a ""
        if (searchText == null)
            searchText = "";
        searchText = searchText.toLowerCase().trim();

        const isMultiFilter = searchText.includes(",");
        const filters = isMultiFilter ? searchText.split(",").map(f => f.split(";")) : [];

        if (isMultiFilter && filters.length > 0) {
            // Pasar el primer filtro
            const [firstColId, firstValue] = filters[0];
            if (firstValue == "" || firstValue == null) {
                this.result = items
            }
            else
                this.result = items.filter(item =>
                    item.values.some(val =>
                        val.columnId === firstColId && this.objectConte(val, firstValue)
                    )
                );

            // Pasar el resto de filtros
            for (let i = 1; i < filters.length; i++) {
                const [colId, value] = filters[i];
                if (value == "" || value == null) {
                    this.result = items
                }
                else
                    this.result = this.result.filter(item =>
                        item.values.some(val =>
                            val.columnId === colId && this.objectConte(val, value)
                        )
                    );
            }
        } else {
            const [colId, value] = searchText.split(";");
            if (value == "" || value == null) {
                this.result = items
            }
            else
                if (colId === "allcolumns") {
                    this.result = items.filter(item =>
                        this.objectConte(item.values, value)
                    );
                } else {
                    this.result = items.filter(item =>
                        item.values.some(val =>
                            val.columnId === colId && this.objectConte(val, value)
                        )
                    );
                }
        }

        this.result.sort((a, b) => {
            let puntsA = this.getPuntuacio(a, searchText, filterMetadata);
            let puntsB = this.getPuntuacio(b, searchText, filterMetadata);

            if (puntsA == puntsB)
                return 0;
            else if (puntsA > puntsB)
                return -1;
            return 1;
        });

        if (filterMetadata && typeof filterMetadata !== 'string') {
            filterMetadata.count = this.result.length;
        }

        return this.result;
    }
    private objectConte(value: any, searchText: string): boolean {
        if (value == null || searchText == null || searchText.trim() === '') return false;
        searchText = searchText.trim().toLowerCase();

        let result = false;

        Object.entries(value).forEach(([key, val]) => {
            if (result || val == null) return;

            if (typeof val === 'number') {
                if (key === 'valueInt' || key === 'valueDouble') {
                    if (String(val).includes(searchText)) {
                        result = true;
                    }
                }
            }

            else if (typeof val === 'string') {
                if (val.toLowerCase().includes(searchText)) {
                    result = true;
                }
            }
            else if (typeof val === 'object') {
                result = this.objectConte(val, searchText);
            }
        });

        return result;
    }


    getPuntuacio(it: any, searchText: string, filterMetadata: any): number {
        if (it == null)
            return 0;
        if ((typeof it) == 'object')
            return this.objectPuntuacio(it, searchText, filterMetadata);
        else if ((typeof it) == 'string') {
            if (it.toLowerCase() === searchText)
                return 100;
            return 0;
        }
        else if ((typeof it) == 'number')
            if (it.toString() === searchText)
                return 100;

    }
    private objectPuntuacio(value: any, searchText: string, filterMetadata: any): number {
        let result = 0;
        Object.entries(value).sort((a: [string, unknown], b: [string, unknown]) => {
            if (!filterMetadata)
                return 0;

            if ((a[0] == filterMetadata && b[0] == filterMetadata) || (a[0] != filterMetadata && b[0] != filterMetadata)) {
                return 0
            } else if ((a[0] == filterMetadata && b[0] != filterMetadata)) {
                return -1;
            } else {
                return 1;
            }
        }).forEach(([key, value]) => {
            if (!result && value != null) {
                if ((typeof value) == 'object') {
                    result = result + this.objectPuntuacio(value, searchText, filterMetadata);
                }
                else if ((typeof value) == 'string') {
                    if (value.toString().toLowerCase() === searchText.toLowerCase()) {
                        if (key === filterMetadata)
                            result = result + 10000;
                        result = result + 1000;
                    }
                    result = result + this.contarPartCoincident(value.toString().toLowerCase(), searchText);
                }
                else if ((typeof value) == 'number')
                    if (value.toString() === searchText) {
                        if (key === filterMetadata)
                            result = result + 1000;
                        result = result + 1000;
                    }
            }
        });
        return result;
    }
    contarPartCoincident(value: string, searchText: string): number {
        if (value == null || searchText == null)
            return 0;

        if (HString.includes(value, searchText))
            return HInteger.min(value.length, searchText.length);
        return 0;
    }
}
